import { Component, OnInit, Input } from '@angular/core';
import { UnityService } from 'src/app/services/unity.service';
import { Set } from 'src/app/models/set';
import { TravelRoute } from 'src/app/models/travel-route';
import { dir } from '../route-create/route-create.component';
import { Expense } from 'src/app/models/expense';
import { Unity } from 'src/app/models/unity';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-route-test',
  templateUrl: './route-test.component.html',
  styleUrls: ['./route-test.component.css']
})
export class RouteTestComponent implements OnInit {
  sets:Set[] = [];
  set:Set;

  unities:Unity[] = [];
  unity:Unity;

  @Input() route:TravelRoute;
  origin:dir;
  destination:dir;

  totalCasetas:number = 0;
  unityname:string = "";
  unittype:string = "";
  isReturn:boolean = false;

  constructor(private unityServ:UnityService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.origin =  {
      lat: Number(this.route.source_customer_address.latitude),
      lng: Number(this.route.source_customer_address.longitude),
    }
    this.destination =  {
      lat: Number(this.route.target_customer_address.latitude),
      lng: Number(this.route.target_customer_address.longitude),
    }

    this.unityServ.getSets().then(sets => {
      this.sets = sets;
    });
    this.unityServ.getUnities().then(unities => {
      this.unities = unities.filter(unity => unity.unit_type.name == 'Torton Plataforma' || unity.unit_type.name == 'Torton Caja Seca' || unity.unit_type.name == 'Torton Volteo' || unity.unit_type.name == 'Camioneta');
    });
  }

  changeSet() {
    //get number of axis
    if(this.set) {
      let axis = this.set.truck.num_rims + this.set.trailer_1.num_rims + 
        (this.set.trailer_2 ? this.set.trailer_2.num_rims : 0) + 
        (this.set.trailer_3 ? this.set.trailer_3.num_rims : 0);

      this.unittype = "Conjunto: ";
      this.unityname = this.set.truck.unit_type.name + " - " + this.set.trailer_1.unit_type.name + 
        (this.set.trailer_2 ? " - " + this.set.trailer_2.unit_type.name : 0) + 
        (this.set.trailer_3 ? " - " + this.set.trailer_3.unit_type.name : 0);
      this.calcCosts(axis);
    }
  }

  changeUni() {
    if(this.unity) {
      this.unittype = "Unidad: ";
      this.unityname = this.unity.id + " - " + this.unity.brand + " (" + this.unity.model + ")";
      this.calcCosts(this.unity.num_rims);
    }
  }

  calcCosts(axis:number) {
    //calc casetas
    this.totalCasetas = 0;

    for (let exp of this.route.expenses) {
      if(exp.expense_type.name == 'Casetas') {
        let expense = exp.axis.find(x => x.axis == axis);
        if(expense) {
          exp.price = expense.price;
          this.totalCasetas += Number(expense.price);
        } else {
          this.toastr.infoToastr("Existe uno o varios gastos de caseta que no han sido configurados con la cantidad de ejes " + axis);
          return;
        }
      }
    }
  }

}
